import { render, staticRenderFns } from "./Truman.vue?vue&type=template&id=3a1da93f&scoped=true"
import script from "./Truman.vue?vue&type=script&lang=js"
export * from "./Truman.vue?vue&type=script&lang=js"
import style0 from "./Truman.vue?vue&type=style&index=0&id=3a1da93f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1da93f",
  null
  
)

export default component.exports